/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { globalBreak } from '@/styles/break';
import { SxProps, Theme } from '@mui/material';

export const productDetailsNameSX: SxProps<Theme> = {
	wordBreak: 'break-word',
	fontSize:globalBreak({mobile:22, desktop:28}),
	fontFamily:'mikado-bold'
};
